import styled from 'styled-components';
import { basicColor, device } from '@/styles/template';

export const ResultHeaderWrap = styled.header`
  color: ${basicColor.white};

  
  @media ${device.mobileL} {
    padding: 2rem 0;
  }
`

